import React from 'react';

import { MDText } from 'i18n-react';

import { VerifiedIcon } from '@motorway/mw-highway-code';

import HandShakeAvif from './assets/handshake.avif';
import HandShakePng from './assets/handshake.png';
import LocalTexts from './DealerVerification.texts.json';
import { DealerVerificationProps } from './DealerVerification.types';

import styles from './DealerVerification.module.scss';

const LocalT = new MDText(LocalTexts);

export const DealerVerification = ({ dealerName, sellerName, value }: DealerVerificationProps) => {
  if (!dealerName || !sellerName || !value) {
    return null;
  }

  return <section className={styles.dealerVerification}>
    <h3>{LocalT.translate('congrats', { sellerName })}</h3>
    <p>{LocalT.translate('carSold', { dealerName, value })}</p>
    <picture>
      <source srcSet={HandShakeAvif} type="image/avif" />
      <img
        alt="handshake icon"
        height="88"
        loading="lazy"
        src={HandShakePng}
        width="152"
      />
    </picture>
    <div className={styles.verifiedDealerContainer}>
      <span className={styles.verifiedDealerIcon}>
        <VerifiedIcon filled={false} size="xsmall" />
      </span>
      {LocalT.translate('verifiedDealer')}
    </div>
  </section>;
};
